var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarInsiderInvestors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.275 3.108L10.125 2L6.945 5.064L10.125 8.129L11.275 7.022L10.056 5.847H14V4.282H10.056L11.275 3.108ZM6.063 5.848H2V4.281H6.063V5.846V5.848ZM4.725 12.897L5.875 14.004L9.055 10.941L5.875 7.875L4.725 8.983L5.944 10.157H2V11.723H5.944L4.725 12.897ZM9.937 10.157H14V11.722H9.937V10.157Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInsiderInvestors);
export default __webpack_public_path__ + "static/media/sidebar-insider-investors.3dfe470148eab74a6a937f4527009a67.svg";
export { ForwardRef as ReactComponent };